import { render, staticRenderFns } from "./WindowGroups.vue?vue&type=template&id=7e304ff0"
import script from "./WindowGroups.vue?vue&type=script&lang=js"
export * from "./WindowGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports